import { NgModule } from '@angular/core';
import { PreloadAllModules, Router, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { PouchService } from './services/pouch-service';

const routes: Routes = [
  {
    path: 'ActivateOfflinePage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./activate-offline/activate-offline.module').then((m) => m.ActivateOfflinePageModule),
  },
  {
    path: 'AddEntityPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./add-entity/add-entity.module').then((m) => m.AddEntityPageModule),
  },
  {
    path: 'AddPaymentPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./add-payment/add-payment.module').then((m) => m.AddPaymentPageModule),
  },
  {
    path: 'AddSettingPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./add-setting/add-setting.module').then((m) => m.AddSettingPageModule),
  },
  {
    path: 'ConflictsManagerPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./conflicts-manager/conflicts-manager.module').then((m) => m.ConflictsManagerPageModule),
  },
  {
    path: 'RestorePage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./restore/restore.module').then((m) => m.RestorePageModule),
  },
  {
    path: 'EntitysPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./entitys/entitys.module').then((m) => m.EntitysPageModule),
  },
  {
    path: 'ChatPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./chat/chat.module').then((m) => m.ChatPageModule),
  },
  {
    path: 'HtmlEditorPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./htmleditor/htmleditor.module').then((m) => m.HtmlEditorPageModule),
  },
  {
    path: 'TasksPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./tasks/tasks.module').then((m) => m.TasksPageModule),
  },
  {
    path: 'UserPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./user/user.module').then((m) => m.UserPageModule),
  },
  {
    path: 'UserTypesPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./user-types/user-types.module').then((m) => m.UserTypesPageModule),
  },
  {
    path: 'ForgotPasswordPage',
    //canActivate: [AuthGuard],
    loadChildren: () => import('./forgot-password/forgot-password.module').then((m) => m.ForgotPasswordPageModule),
  },
  {
    path: 'LoginPage',
    //canActivate: [AuthGuard],
    loadChildren: () => import('./login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'LoginUserPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./login-user/login-user.module').then((m) => m.LoginUserPageModule),
  },
  {
    path: 'PaymentsPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./payments/payments.module').then((m) => m.PaymentsPageModule),
  },
  {
    path: 'PreloadPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./preload/preload.module').then((m) => m.PreloadPageModule),
  },
  {
    path: 'ReportsPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./reports/reports.module').then((m) => m.ReportPageModule),
  },
  {
    path: 'SignupPage',
    //canActivate: [AuthGuard],
    loadChildren: () => import('./signup/signup.module').then((m) => m.SignupPageModule),
  },
  {
    path: 'SettingsPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsPageModule),
  },
  {
    path: 'ViewAllEntitiesPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./view-all-entities/view-all-entities.module').then((m) => m.ViewAllEntitiesPageModule),
  },
  {
    path: 'SystemSettingsPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./system-settings/system-settings.module').then((m) => m.SystemSettingsPageModule),
  },
  {
    path: 'PreloadPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./preload/preload.module').then((m) => m.PreloadPageModule),
  },
  {
    path: 'MedicationRecordPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./medication-record/medication-record.module').then((m) => m.MedicationRecordPageModule),
  },
  {
    path: 'CalendarPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./calendar/calendar.module').then((m) => m.CalendarPageModule),
  },
  {
    path: 'CustomerManagementPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./customer_management/customer_management.module').then((m) => m.CustomerManagementPageModule),
  },
  {
    path: 'FormPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./form/form.module').then((m) => m.FormPageModule),
  },
  {
    path: 'FileViewerPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./fileviewer/fileviewer.module').then((m) => m.FileViewerPageModule),
  },
  {
    path: 'PrescriptionManagementPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./prescription-management/prescription-management.module').then((m) => m.PrescriptionManagementPageModule),
  },
  {
    path: 'PrescriptionsPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./prescriptions/prescriptions.module').then((m) => m.PrescriptionsPageModule),
  },
  {
    path: 'BillingPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./billing/billing.module').then((m) => m.BillingPageModule),
  },
  {
    path: 'ZoomPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./zoom/zoom.module').then((m) => m.ZoomModule),
  },
  {
    path: 'LaboratoryPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./laboratory/laboratory.module').then((m) => m.LaboratoryPageModule),
  },
  {
    path: 'RadiologyPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./radiology/radiology.module').then((m) => m.RadiologyPageModule),
  },
  {
    path: 'DailyReportPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./daily-report/daily-report.module').then((m) => m.DailyReportPageModule),
  },
  {
    path: 'PrintReceiptPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./print-receipt/print-receipt.module').then((m) => m.PrintReceiptPageModule),
  },
  {
    path: 'PrintEntityPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./print-entity/print-entity.module').then((m) => m.PrintEntityPageModule),
  },
  {
    path: 'PrintSalaryPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./print-salary/print-salary.module').then((m) => m.PrintSalaryPageModule),
  },
  {
    path: 'ProductsPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./products/products.module').then((m) => m.ProductsPageModule),
  },
  {
    path: 'PosPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pos/pos.module').then((m) => m.PosPageModule),
  },
  {
    path: 'StoresPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./stores/stores.module').then((m) => m.StoresPageModule),
  },
  {
    path: 'InsurancePage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./insurance/insurance.module').then((m) => m.InsurancePageModule),
  },
  {
    path: 'ExpiryPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./expiry/expiry.module').then((m) => m.ExpiryPageModule),
  },
  {
    path: 'PurchasesPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./purchases/purchases.module').then((m) => m.PurchasesPageModule),
  },
  {
    path: 'StockTakingPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./stock-taking/stock-taking.module').then((m) => m.StockTakingPageModule),
  },
  {
    path: 'PrintBarcodePage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./print-barcode/print-barcode.module').then((m) => m.PrintBarcodePageModule),
  },
  {
    path: 'PrintItemPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./print-item/print-item.module').then((m) => m.PrintItemPageModule),
  },
  {
    path: 'DrugDictionaryPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./drug-dictionary/drug-dictionary.module').then((m) => m.DrugDictionaryPageModule),
  },
  {
    path: 'SpecimenCollectionPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./specimen-collection/specimen-collection.module').then((m) => m.SpecimenCollectionPageModule),
  },
  {
    path: 'SpecimenReceptionPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./specimen-reception/specimen-reception.module').then((m) => m.SpecimenReceptionPageModule),
  },
  {
    path: 'PayrollPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./payroll/payroll.module').then((m) => m.PayrollPageModule),
  },
  {
    path: 'FacilityBookingPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./facility-booking/facility-booking.module').then((m) => m.FacilityBookingPageModule),
  },
  {
    path: 'MaintenanceRecordPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./maintenance-record/maintenance-record.module').then((m) => m.MaintenanceRecordPageModule),
  },
  {
    path: 'RotaPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./rota/rota.module').then((m) => m.RotaPageModule),
  },
  {
    path: 'PatientManagementPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./patient-management/patient-management.module').then((m) => m.PatientManagementPageModule),
  },
  {
    path: 'BillManagementPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./bill-management/bill-management.module').then((m) => m.BillManagementPageModule),
  },
  {
    path: 'SummaryInventoryPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./summary-inventory/summary-inventory.module').then((m) => m.SummaryInventoryPageModule),
  },
  {
    path: 'InventoryPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./inventory/inventory.module').then((m) => m.InventoryPageModule),
  },
  {
    path: 'PrintQuotationPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./print-quotation/print-quotation.module').then((m) => m.PrintQuotationPageModule),
  },
  {
    path: 'QuotationsPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./quotations/quotations.module').then((m) => m.QuotationsPageModule),
  },
  {
    path: 'PharmacyPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pharmacy/pharmacy.module').then((m) => m.PharmacyPageModule),
  },
  {
    path: 'ZoomConnectPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./zoom-connect/zoom-connect.module').then((m) => m.ZoomConnectPageModule),
  },
  {
    path: '**',
    loadChildren: () => import('./preload/preload.module').then((m) => m.PreloadPageModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(private router: Router, private db: PouchService) {
    this.router.config.unshift({
      path: 'SignupPage',
      loadChildren: () => import('./signup/signup.module').then((m) => m['SignupPageModule']),
    });
  }
}
